"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Action = /** @class */ (function () {
    function Action(type, data) {
        this.type = type;
        this.data = data;
    }
    return Action;
}());
exports.default = Action;
//# sourceMappingURL=Action.js.map